// @ts-nocheck
import { GreifOrderUploadModel } from "@store/Framework/Types/ApiModels";
import {
    GetGreifOrderUploadApiParameter,
    uploadAndValidateFile,
} from "@store/Framework/Services/GreifOrderUploadService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = Pick<GreifOrderUploadModel, "documents"> & HasOnError;
type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetGreifOrderUploadApiParameter, GreifOrderUploadModel>;

export const DispatchBeginUpload: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/BeginUploadAndValidateFile",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { ...apiParameter } = props.parameter;
    props.apiParameter = {
        greifOrderUploadParameter: apiParameter,
    } as any;
};

export const UploadAndValidateFile: HandlerType = async props => {
    const result = await uploadAndValidateFile(props.apiParameter);
    if (result.successful) {
        const { document, errors } = result.result;
        props.apiResult = result.result;
        props.dispatch({
            type: "Greif/Components/GreifOrderUpload/DispatchSuccessfulValidationResults",
            document,
            errors,
        });
    } else {
        props.parameter?.onError?.(result as any);
        props.dispatch({
            type: "Greif/Components/GreifOrderUpload/FailedToUploadAndValidateFile",
            error: result.statusCode !== 401 ? result.errorMessage : undefined,
        });
    }
};

export const DispatchCompleteUpload: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/CompleteUploadAndValidateFile",
    });
};

export const chain = [DispatchBeginUpload, PopulateApiParameter, UploadAndValidateFile, DispatchCompleteUpload];

const uploadAndValidateOrder = createHandlerChainRunner(chain, "UploadAndValidateOrderUpload");
export default uploadAndValidateOrder;
